import { render } from "./News03.vue?vue&type=template&id=3ec5b116"
import script from "./News03.vue?vue&type=script&lang=js"
export * from "./News03.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__